import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/tailwind.css'
import 'element-ui/lib/theme-chalk/index.css'
import store from '@/store/index'
import ElementUI from 'element-ui'
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 